import { CaseDetailsActionResult } from '../models/case-action-result.models';
import { CaseDetails, CaseEvidence, CaseFolder, CaseMemberDetails } from '../models/case.models';

export const CASE_DETAILS_STATE_KEY = 'case-details';

export interface ICaseDetailsState {
  caseUid: string | null;
  caseDetails: CaseDetails | null;
  isLoading: boolean;
  evidenceFiles: CaseEvidence[];
  evidenceFilesLoading: boolean;
  evidenceFolders: CaseFolder[];
  actionResult: CaseDetailsActionResult | null;
  evidenceFoldersLoading: boolean;
  caseMembers: CaseMemberDetails[];
  caseMembersLoading: boolean;
}

export const initialState: ICaseDetailsState = {
  caseUid: null,
  caseDetails: null,
  isLoading: false,
  evidenceFiles: [],
  evidenceFilesLoading: false,
  evidenceFolders: [],
  actionResult: null,
  evidenceFoldersLoading: false,
  caseMembers: [],
  caseMembersLoading: false,
};
